export default {
  title: '¿Seguro que quieres cerrar sesión?',
  buttons: {
    logout: 'Cerrar sesión',
    cancel: 'Cancelar',
  },
};
